
import { defineComponent, nextTick, ref, watch } from 'vue'
import { copyText } from '@/utils/tool'

export default defineComponent({
  props: {
    value: {
      type: String,
      default: ''
    },
    propsShow: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },

  setup (props, context) {
    const selfValue = ref('')
    const isEdit = ref(false)
    const inputNode = ref()
    const isCodeShow = ref(false)

    function startEdit () {
      isEdit.value = true
      nextTick(() => inputNode.value?.focus())
    }

    function handleBlur () {
      isEdit.value = false
      if (selfValue.value) {
        context.emit('blur', selfValue.value)
      } else {
        selfValue.value = props.value
      }
    }

    watch(() => props.value, (value) => {
      selfValue.value = value
    }, { immediate: true })

    watch(() => props.propsShow, (value) => {
      isCodeShow.value = value
    }, { immediate: true })

    return {
      isEdit,
      isCodeShow,
      inputNode,
      selfValue,
      startEdit,
      handleBlur,
      copyText,
    }
  }
})
